import { render, staticRenderFns } from "./PopulationWastewater.vue?vue&type=template&id=33fe5774&"
import script from "./PopulationWastewater.vue?vue&type=script&lang=js&"
export * from "./PopulationWastewater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports